import CandidateMatchScoresScreen from 'pages/iPriseV2/common/candidate-match-scores';
import ViewCandidate from 'pages/iPriseV2/common/view-candidate';
import ViewJobV2 from 'pages/iPriseV2/common/view-job';
import ViewMatchedCandidate from 'pages/iPriseV2/common/view-matched-candidate';
import JobQueue from 'pages/iPriseV2/support/job-queue';
import Header from 'pages/iPriseV2/support/layout/Header';
import SupportProfile from 'pages/iPriseV2/support/profile';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const SupportRoutes = () => {
  return (
    <Routes>
      <Route path="support" element={<Header />}>
        <Route index element={<Navigate to="job-queue" replace />} />
        <Route path="job-queue" element={<JobQueue />} />
        <Route path="view-job/:id" element={<ViewJobV2 />} />
        <Route
          path="view-matched-candidate"
          element={<ViewMatchedCandidate />}
        />
        <Route
          path="view-matched-candidate-scores"
          element={<CandidateMatchScoresScreen />}
        />
        <Route path="view-candidate/:candidateId" element={<ViewCandidate />} />
        <Route path="profile" element={<SupportProfile />} />
      </Route>
      {/* Redirect any unknown route to support/job-queue */}
      <Route path="*" element={<Navigate to="support/job-queue" replace />} />
    </Routes>
  );
};

export default SupportRoutes;
